import request from '@/utils/request.js'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    // url: '/doLogin',
    url: '/webLogin',
    method: 'post',
    data: data
  })
}

// 钉钉免登方法
export function dingLogin(authCode) {
  return request({
    url: '/dingLogin?authCode=' + authCode,
    method: 'get'
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取图片验证码
export function getCodeImgOne() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}
//登录获取验证码
export function getCodeImg(phone) {
  return request({
    url: '/sendSmsVerifyCode',
    method: 'get',
    params:phone
  })
}
//验证码登录
export function CodeLogin(phone) {
  return request({
    url: '/smsLogin',
    method: 'get',
    params:phone
  })
}
//验证短信验证码
export function verifyPasswordCode(phone) {
  return request({
    url: '/verifyChangePasswordCode',
    method: 'get',
    params: phone
  })
}
//修改密码
export function getchangePwdByPhone(phone) {
  return request({
    url: '/changePwdByPhone',
    method: 'post',
    params: phone
  })
}

// 获取RSA公钥
export function getPublicKey() {
  return request({
    url: '/getPublicKey',
    method: 'get'
  })
}


// 用户重置自己的密码
export function changePwdByOldPwd(oldPwd, newPwd) {
  const data = new FormData()
  data.append('oldPwd', oldPwd)
  data.append('newPwd', newPwd)
  return request({
    url: '/system/user/changePwdByOldPwd',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取SM2公钥
export function getSM2PublicKey() {
  return request({
    url: '/getSM2PublicKey',
    method: 'get'
  })
}

// 扫码登录
export function dingScanLogin({ authCode }) {
  return request({
    url: '/dingScanLogin',
    method: 'get',
    params: { authCode }
  })
}
